module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-top-backplates.07c5879e.png";